import {datadogLogs, LogsEvent, LogsEventDomainContext} from '@datadog/browser-logs';

function beforeSend(event: LogsEvent, context: LogsEventDomainContext): boolean {
  // Ignore network request errors to 3rd parties
  if (
    event.origin === 'network' &&
    event.message.includes('XHR error') &&
    !event.http?.url.includes(origin)
  ) {
    return false;
  }
  return true;
}

export function configureDatadogLogs(clientToken: string): void {
  datadogLogs.init({
    clientToken,
    site: 'datadoghq.com',
    service: 'benchling-web',
    forwardErrorsToLogs: true,
    forwardReports: ['csp_violation'],
    beforeSend,
    sessionSampleRate: 100,
    useSecureSessionCookie: true,
    env: window.DEPLOY_ENVIRONMENT,
    version: window.REVISION,
  });
  datadogLogs.setGlobalContext({
    deploy: window.DEPLOY_NAME,
    tenant: window.TENANT_SUBDOMAIN,
  });
}
